import { AfterViewInit, Component } from '@angular/core';
import { HomePage } from '../../pages/home/home';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { HomePage_PATH } from '../../app/app-constants';

/**
 * Generated class for the BeerHiveLogoComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'beer-hive-logo',
  templateUrl: 'beer-hive-logo.html',
  styleUrls: ['./beer-hive-logo.scss'],
  standalone: false,
  // imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class BeerHiveLogoComponent implements AfterViewInit {

  constructor(
    public router: Router
  ) { }

  ngAfterViewInit() {

  }

  logoClick() {
    console.log("[beer-hive-logo] click on logo, go to home page");
    // this.navController.push(HomePage); // TODO should work with push
    this.router.navigate([ HomePage_PATH ])
  }

  handleUserId(result: any) {
    //console.log("result: " + result);
    //console.log("id: " + result.id);
  }
}
